import { render, staticRenderFns } from "./ProductAutocomplete.vue?vue&type=template&id=4452de2a"
import script from "./ProductAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProductAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./ProductAutocomplete.vue?vue&type=style&index=0&id=4452de2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports